import { Outlet, useParams } from 'react-router-dom';

import { Container } from '@mui/material';

import AgencyProfileProgressInfo from './layout-components/layout-header/AgencyProfileProgressInfo';
import LayoutHeader from './layout-components/layout-header/LayoutHeader';
import LayoutTabs from './layout-components/layout-tabs/LayoutTabs';
import PaymentStatusListener from './users-sections/staff-roster/sections/member-certificate-section/components/payment-status-listener/PaymentStatusListener';

export default function AgencyProfileLayout() {
  const { id = '' } = useParams();

  return (
    <Container maxWidth="lg">
      <PaymentStatusListener />
      <LayoutHeader />
      <AgencyProfileProgressInfo companyId={id} />
      <LayoutTabs companyId={id} />
      <Outlet />
    </Container>
  );
}
